import {
  ValidatedSetLens3tjmcbmmtgp0c as ValidatedSetLens,
  ValidatedModifyLensxnr6y4izl6zn as ValidatedModifyLens,
  ValidatedSetValueLens1a0iz59dg9w6t as ValidatedSetValueLens,
  ValidatedModifyValueLensyxkqbmnu4076 as ValidatedModifyValueLens,
} from './validationLenses.mjs';
import {
  MutableReactive2qdhhyljdknhy as MutableReactive,
  Reactive1jy75v4li6ldv as Reactive,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
} from '../../core/coreInterfaces.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_issues(_this__u8e3s4) {
  return _this__u8e3s4.xat().rat_1;
}
function lens(get, set) {
  return ValidatedSetLens().fau(this, get, set);
}
function lens_0(get, modify) {
  return ValidatedModifyLens().nau(this, get, modify);
}
var MutableValidatedClass;
function MutableValidated() {
  if (MutableValidatedClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableValidated', VOID, VOID, [MutableReactive(), Reactive()], [1]);
    MutableValidatedClass = $;
  }
  return MutableValidatedClass;
}
function lens_1(get, set) {
  return ValidatedSetValueLens().vau(this, get, set);
}
function lens_2(get, modify) {
  return ValidatedModifyValueLens().dav(this, get, modify);
}
var MutableValidatedValueClass;
function MutableValidatedValue() {
  if (MutableValidatedValueClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableValidatedValue', VOID, VOID, [MutableReactiveValue(), Reactive(), ReactiveValue(), MutableValidated()], [1]);
    MutableValidatedValueClass = $;
  }
  return MutableValidatedValueClass;
}
function report(_this__u8e3s4, issue) {
  return _this__u8e3s4.xat().tat(issue);
}
//region block: exports
export {
  lens_0 as lens2dr2mfn274h1a,
  lens as lensi9s8q1zaykbw,
  lens_2 as lens2wuprihu5z787,
  lens_1 as lens2gvfhjoqnpofs,
  MutableValidatedValue as MutableValidatedValuegls7jkstsdwb,
  MutableValidated as MutableValidated2ognu5vxf17ur,
  get_issues as get_issues1z1skb5sgeygq,
  report as report3fj81patexuuw,
};
//endregion

//# sourceMappingURL=Validated.mjs.map
